import $ from 'jquery';
import _ from 'underscore';
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { NavigateModal } from '@bingads-webui-campaign-react/recommendation-navigate-modal';
import { NAVIGATE_REASON } from '@bingads-webui-campaign-react/recommendation-feedback-modal';
import {
  RECOMMENDATION_TYPES,
} from '@bingads-webui-campaign/recommendation-core';
import { DismissFeedbackForm } from './dismiss-feedback-form';
import { SingleChoiceDismissFeedbackForm } from './single-choice-dismiss-feedback-form';
import template from './fixed-container.pug';
import budgetTemplate from './fixed-container-for-budget-landscape.pug';
import { REASON_TABLE } from './single-choice-reason-const';

class FeedbackView extends React.PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    rejectAutoApplySuggestedAds: PropTypes.bool,
    permissions: PropTypes.objectOf(PropTypes.any),
    newI18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func,
    }),
    type: PropTypes.string.isRequired,
    viewDetails: PropTypes.func,
    recommendationTypesAvailable: PropTypes.arrayOf(PropTypes.any),
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    isAutoClose: PropTypes.bool,
  };

  static defaultProps = {
    rejectAutoApplySuggestedAds: false,
    permissions: {},
    newI18n: {
      getString: _.noop,
    },
    viewDetails: _.noop,
    recommendationTypesAvailable: [],
    isAutoClose: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: true,
      submitDisabled: true,
      timer: null,
      isNavigateModalOpen: false,
      navigateToDetailType: RECOMMENDATION_TYPES.REALLOCATE_BUDGET,
    };
    this.form = React.createRef();
    this.isShowNewDismissForm = props.permissions.IsRecommendationInProductFeedbackLoopEnabled &&
      REASON_TABLE[props.type];
    this.isCloseClickOverlay = props.isAutoClose;
  }

  componentDidMount() {
    document.onclick = (e) => {
      if (this.state.submitDisabled &&
         !this.form.current.contains(e.target) &&
         this.isCloseClickOverlay) {
        // feedback in budget landscape won't hide when user click overlay.
        this.hide();
      }
      // when open feedback in budget landscape,
      // this.form.current would not contain e.target
      // in the first time, so we need to add a mechanism
      // to make it not disappear in the first time.
      this.isCloseClickOverlay = true;
    };
    this.timer(true);
  }
  componentWillUnmount() {

  }

  // For Navigate Modal
  onYes = () => {
    this.setState({ isNavigateModalOpen: false });
    this.props.viewDetails(this.state.navigateToDetailType)();
  };

  onNo = () => {
    this.setState({
      isNavigateModalOpen: false,
    });
  };

  onSubmit = (data, reasonId = null) => {
    const {
      onSubmit, type,
    } = this.props;

    if (type === 'budgetLandscape') onSubmit(data, reasonId);
    else onSubmit(data, this.isShowNewDismissForm);

    this.hide();

    if (this.isShowNewDismissForm && reasonId) {
      this.navigateBasedOnReasonId(reasonId);
    }
  };

  navigateBasedOnReasonId = (reasonId) => {
    if (reasonId) {
      switch (reasonId) {
        case (NAVIGATE_REASON.NoBudget): // open navigate modal for certain reason
        case (NAVIGATE_REASON.BudgetNoBudget):
        {
          if (this.props.recommendationTypesAvailable
            .includes(RECOMMENDATION_TYPES.REALLOCATE_BUDGET)) {
            // open navigate modal
            this.setState({
              isNavigateModalOpen: true,
              navigateToDetailType: RECOMMENDATION_TYPES.REALLOCATE_BUDGET,
            });
          }
          break;
        }
        default:
          break;
      }
    }
  };

  hide = () => {
    this.setState({ isOpen: false });
    this.timer(false);
    document.onclick = null;
  };
  timer(val) {
    let timer = null;
    if (this.state.timer) {
      clearTimeout(this.state.timer);
    }
    if (val && this.props.isAutoClose) {
      timer = setTimeout(() => { this.hide(); }, 15000);
    }
    this.setState({ timer });
  }
  changeState = (val) => {
    if (val !== this.state.submitDisabled) {
      this.setState({ submitDisabled: val });
    }
    this.timer(false);
  };

  render() {
    const { rejectAutoApplySuggestedAds, i18n, type } = this.props;

    // for position:absolute in popover css, we need to put the close button to form
    // to prevent close button disappear.
    const isForBudgetLandscape = type === 'budgetLandscape';

    const navigateModal = (
      this.state.isNavigateModalOpen &&
        <NavigateModal
          isOpen={this.state.isNavigateModalOpen}
          i18n={i18n}
          onYes={this.onYes}
          onNo={this.onNo}
          recommendationType={this.state.navigateToDetailType}
          // eslint-disable-next-line indent
        />
    );

    return (
      <div ref={this.form} >
        {this.state.isOpen &&
        <React.Fragment>
          {!isForBudgetLandscape && <button className="close closeimage" aria-label="Close" onClick={this.hide} />}
          {!this.isShowNewDismissForm &&
          <DismissFeedbackForm
            {...this.props}
            onSubmit={this.onSubmit}
            changeState={this.changeState}
            rejectAutoApplySuggestedAds={rejectAutoApplySuggestedAds}
            recommendationType={this.props.type}
          />}
          {this.isShowNewDismissForm &&
          <SingleChoiceDismissFeedbackForm
            {...this.props}
            onSubmit={this.onSubmit}
            changeState={this.changeState}
            rejectAutoApplySuggestedAds={rejectAutoApplySuggestedAds}
            onCancel={this.hide}
          />}
        </React.Fragment>}
        {navigateModal}
      </div>
    );
  }
}

export function showDismissFeedbackPopup({
  newI18n,
  i18n,
  type,
  onSubmit,
  rejectAutoApplySuggestedAds,
  permissions,
  recommendationTypesAvailable,
  viewDetails,
}) {
  const container = document.querySelector('.recommendation-dismiss-feedback-popup');
  if (container === null) {
    $('body').append(template());
  } else {
    ReactDOM.unmountComponentAtNode(container);
  }
  ReactDOM.render(
    (<FeedbackView
      newI18n={newI18n}
      i18n={i18n}
      type={type}
      onSubmit={onSubmit}
      rejectAutoApplySuggestedAds={rejectAutoApplySuggestedAds}
      permissions={permissions}
      recommendationTypesAvailable={recommendationTypesAvailable}
      viewDetails={viewDetails}
    />),
    document.querySelector('.recommendation-dismiss-feedback-popup')
  );
}

export function showDismissFeedbackPopupForBudgetLandscape({
  newI18n,
  i18n,
  onSubmit,
  permissions,
  el,
}) {
  const budgetLandscapePopup = '.budget-landscape-dismiss-popup';
  const container = document.querySelector(budgetLandscapePopup);
  if (container === null) {
    $(el).append(budgetTemplate()); // .popup-container
  } else {
    ReactDOM.unmountComponentAtNode(container);
  }
  ReactDOM.render(
    (<FeedbackView
      newI18n={newI18n}
      i18n={i18n}
      type="budgetLandscape"
      onSubmit={onSubmit}
      permissions={permissions}
      isAutoClose={false}
    />),
    document.querySelector(budgetLandscapePopup)
  );
}

